import type { Config } from 'dompurify';

/** Keep in sync with admin-frontend `sanitizeBannerHtml` allowlist (`i`, `b`, `strong`, `u`). */
export const LIVE_BANNER_PURIFY_CONFIG: Config = {
  ALLOWED_TAGS: ['b', 'i', 'strong', 'u'],
  ALLOWED_ATTR: [],
};
